import React, { useState, useEffect } from 'react';
import { addAlert, getAlertsByUserId, handleDeleteAlert, getAlertProducts, markNotificationAsSeen } from '../../firebase/config'
import { useAuth } from '../../context/AuthContext';
import "./Alertas.css"
import { upperFL } from '../../utils/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faTimes } from '@fortawesome/free-solid-svg-icons'
import { csvDataVariable } from "./menuJerarquicoData";
import { ProductosPopup } from '../Alertas/ProductosPopup/ProductosPopup';
import { Timestamp } from "firebase/firestore";

export const Alertas = () => {
  const { user, premium, planName } = useAuth();
  const usarIA = ['Plan Explora+', 'Plan Radar', 'Plan Radar+'].includes(planName);
  const getPlanLimit = (planName) => {
    switch (planName?.toLowerCase()) {
      case 'plan explora':
        return 25;
      case 'plan explora+':
        return 50;
      case 'plan radar':
        return 100;
      case 'plan radar+':
        return 200;
      default:
        return 1;
    }
  };
  
  const [alerta, setAlerta] = useState({
    tituloAlerta: '',
    hierarchicalCategories: {
      lvl0: '',
      lvl1: '',
      lvl2: ''
    },
    sexo: '',
    talla: '',
    estado: '',
    marca: '',
    color: '',
    ubicacion: '',
    precioMax: '',
    rebajaEuros:'',
    rebajaPorcentaje:'',
    notificationState: false,
    newProductsCount: 0,
    totalProductsCount: 0,
    fecha: Timestamp.now()
  });

  const csvData = csvDataVariable;
  const [filtro, setFiltro] = useState("");


  const getLvl0Options = (sexo) => {
    return [...new Set(csvData
      .filter(item => item.sexo === sexo)
      .map(item => item.lvl0)
    )];
  };
  
  const getLvl1Options = (sexo, lvl0) => {
    return [...new Set(csvData
      .filter(item => 
        item.sexo === sexo && 
        item.lvl0 === lvl0 && 
        item.lvl1.trim()
      )
      .map(item => item.lvl1)
    )];
  };
  
  const getLvl2Options = (sexo, lvl0, lvl1) => {
    return [...new Set(csvData
      .filter(item => 
        item.sexo === sexo && 
        item.lvl0 === lvl0 && 
        item.lvl1 === lvl1 && 
        item.lvl2.trim()
      )
      .map(item => item.lvl2)
    )];
  };

    const handleChange = (e) => {
      const { name, value } = e.target;
      let newValue = value;

      // Aplica el límite solo a los campos específicos
      if (name === "rebajaEuros" || name === "rebajaPorcentaje") {
        const num = Number(value);
        if (num > 0) newValue = 0;
        if (num < -100) newValue = -100;
      }

      setAlerta({ ...alerta, [name]: newValue });
    };


    const [alertasGuardadas, setAlertasGuardadas] = useState([]);

    
    useEffect(() => {
      const fetchAlerts = async () => {
        try {
          if (user && user.uid) {
            const alerts = await getAlertsByUserId(user.uid);
            setAlertasGuardadas(sortAlertas(alerts));
            localStorage.setItem('alertas', JSON.stringify(alerts)); // Guardar en localStorage
          }
        } catch (error) {
          console.error('Error al obtener las alertas:', error);
        }
      };
      fetchAlerts();
    }, [user]);

    const handleDeleteAndRefresh = async (userId, alertId) => {
      try {
        await handleDeleteAlert(userId, alertId);
        const updatedAlerts = alertasGuardadas.filter(alert => alert.id !== alertId);
        setAlertasGuardadas(sortAlertas(updatedAlerts));
        localStorage.setItem('alertas', JSON.stringify(updatedAlerts)); // Actualizar localStorage
      } catch (error) {
        console.error('Error al eliminar la alerta:', error);
      }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

        const tituloExistente = alertasGuardadas.some(
          (alert) => alert.data.tituloAlerta.trim().toLowerCase() === alerta.tituloAlerta.trim().toLowerCase()
        );

        if (tituloExistente) {
          alert("Ya existe una alerta con ese título. Por favor, elige otro nombre.");
          return; // No continuar con la creación
        }
  
      const formattedCategories = {
        lvl0: alerta.hierarchicalCategories.lvl0,
        lvl1: alerta.hierarchicalCategories.lvl1 
          ? `${alerta.hierarchicalCategories.lvl0} > ${alerta.hierarchicalCategories.lvl1}`
          : '',
        lvl2: alerta.hierarchicalCategories.lvl2 
          ? `${alerta.hierarchicalCategories.lvl0} > ${alerta.hierarchicalCategories.lvl1} > ${alerta.hierarchicalCategories.lvl2}`
          : ''
      };
    
      const alertaConFecha = { 
        ...alerta, 
        hierarchicalCategories: formattedCategories,
        creationDate: Date.now() 
      };

      try {
        const alertId = await addAlert(user.uid, alertaConFecha, premium, planName );
        const newAlert = { id: alertId, data: alertaConFecha };
        setAlertasGuardadas(sortAlertas([...alertasGuardadas, newAlert])); // Agrega la nueva alerta al estado
    
        // Cargar los productos de la nueva alerta
        const productos = await getAlertProducts(alertaConFecha);
        setProducts({
          ...products,
          [alertId]: productos
        }); // Agrega los productos al estado de productos usando el ID de la alerta como clave
      } catch (error) {
        console.error('Error al crear la alerta:', error);
        alert(error.message);
        // Manejar el error según sea necesario
      }
    };
    


    const [products, setProducts] = useState({});
    const [selectedAlert, setSelectedAlert] = useState(null); // guarda alerta seleccionada
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const toggleProducts = async (alertId) => {
      const alertIndex = alertasGuardadas.findIndex(alert => alert.id === alertId);
      if (alertIndex === -1) return;
    
      const alertaSeleccionada = alertasGuardadas[alertIndex];
      
      // 👉 primero seleccionamos la alerta y abrimos popup
      setSelectedAlert(alertaSeleccionada);
      setIsPopupOpen(true);
    
      // 👉 marcamos productos como "loading"
      setProducts(prev => ({ ...prev, [alertId]: undefined }));
    
      try {
        const productos = await getAlertProducts(alertaSeleccionada.data);
        setProducts(prev => ({ ...prev, [alertId]: Array.isArray(productos) ? productos : [] }));
      } catch (err) {
        console.error("Error al cargar productos:", err);
        setProducts(prev => ({ ...prev, [alertId]: [] }));
      }
    
      // 👉 después manejamos notificación
      if (alertaSeleccionada.data.notificationState) {
        try {
          await markNotificationAsSeen(user.uid, alertId);
          setAlertasGuardadas(prevAlertas =>
            prevAlertas.map(alert =>
              alert.id === alertId
                ? {
                    ...alert,
                    data: {
                      ...alert.data,
                      notificationState: false,
                      newProductsCount: 0, // 👈 resetea el contador también en frontend
                    },
                  }
                : alert
            )
          );          
        } catch (err) {
          console.error("Error al marcar notificación como vista:", err);
        }
      }
    };

    const sortAlertas = (alertasArray) => {
      return [...alertasArray].sort((a, b) => {
        // 1️⃣ Alertas con notificación activa arriba
        if (a.data.notificationState && !b.data.notificationState) return -1;
        if (!a.data.notificationState && b.data.notificationState) return 1;
    
        // 2️⃣ Alertas sin fecha al final
        if (!a.data.fecha && b.data.fecha) return 1;
        if (a.data.fecha && !b.data.fecha) return -1;
        if (!a.data.fecha && !b.data.fecha) return 0;
    
        // 3️⃣ Orden descendente por fecha
        return b.data.fecha.toMillis() - a.data.fecha.toMillis();
      });
    };

    
    
  return (
    <div>
      <div className="alerts-dashboard">
        <div className="metrics">
          <div className="metric-box">
            <h4>Límite</h4>
            <p>{getPlanLimit(planName)}</p>
          </div>
          <div className="metric-box">
            <h4>Usadas</h4>
            <p>{alertasGuardadas.length}</p>
          </div>
          <div className="metric-box">
            <h4>Disponibles</h4>
            <p>{getPlanLimit(planName) - alertasGuardadas.length}</p>
          </div>
        </div>

        <div className="progress-bar-container">
          <div
            className="progress-bar-fill"
            style={{
              width: `${
                getPlanLimit(planName) > 0
                  ? Math.min((alertasGuardadas.length / getPlanLimit(planName)) * 100, 100)
                  : 0
              }%`,
            }}
          />
        </div>
      </div>
      <div className='alertas'>
        <div className='crear-alertas'>
          <h2>Crear Alerta de Producto</h2>
          <p>Los campos con * son obligatorios</p>
          <form onSubmit={handleSubmit} className='form-container'>
            <div>
              <label htmlFor="tituloAlerta">*Título:</label>
              <input
                type="text"
                id="tituloAlerta"
                name="tituloAlerta"
                value={alerta.tituloAlerta}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label htmlFor="sexo">*Sexo:</label>
              <select
                id="sexo"
                value={alerta.sexo}
                onChange={(e) => {
                  const newSexo = e.target.value;
                  setAlerta(prev => ({
                    ...prev,
                    sexo: newSexo,
                    hierarchicalCategories: { lvl0: '', lvl1: '', lvl2: '' }
                  }));
                }}
                required
              >
                <option value="">Seleccionar</option>
                <option value="hombre">Hombre</option>
                <option value="mujer">Mujer</option>
              </select>
            </div>

            {alerta.sexo && (
              <div>
                <label htmlFor="lvl0">*Categoría Principal:</label>
                <select
                  id="lvl0"
                  value={alerta.hierarchicalCategories.lvl0}
                  onChange={(e) => {
                    const newLvl0 = e.target.value;
                    setAlerta(prev => ({
                      ...prev,
                      hierarchicalCategories: {
                        lvl0: newLvl0,
                        lvl1: '',
                        lvl2: ''
                      }
                    }));
                  }}
                  required
                >
                  <option value="">Seleccionar</option>
                  {getLvl0Options(alerta.sexo).map(option => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </div>
            )}

            {alerta.hierarchicalCategories.lvl0 && getLvl1Options(alerta.sexo, alerta.hierarchicalCategories.lvl0).length > 0 && (
              <div>
                <label htmlFor="lvl1">Subcategoría Nivel 1:</label>
                <select
                  id="lvl1"
                  value={alerta.hierarchicalCategories.lvl1}
                  onChange={(e) => {
                    const newLvl1 = e.target.value;
                    setAlerta(prev => ({
                      ...prev,
                      hierarchicalCategories: {
                        ...prev.hierarchicalCategories,
                        lvl1: newLvl1,
                        lvl2: ''
                      }
                    }));
                  }}
                >
                  <option value="">Seleccionar (opcional)</option>
                  {getLvl1Options(alerta.sexo, alerta.hierarchicalCategories.lvl0).map(option => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </div>
            )}

            {alerta.hierarchicalCategories.lvl1 && getLvl2Options(alerta.sexo, alerta.hierarchicalCategories.lvl0, alerta.hierarchicalCategories.lvl1).length > 0 && (
              <div>
                <label htmlFor="lvl2">Subcategoría Nivel 2:</label>
                <select
                  id="lvl2"
                  value={alerta.hierarchicalCategories.lvl2}
                  onChange={(e) => {
                    const newLvl2 = e.target.value;
                    setAlerta(prev => ({
                      ...prev,
                      hierarchicalCategories: {
                        ...prev.hierarchicalCategories,
                        lvl2: newLvl2
                      }
                    }));
                  }}
                >
                  <option value="">Seleccionar (opcional)</option>
                  {getLvl2Options(
                    alerta.sexo,
                    alerta.hierarchicalCategories.lvl0,
                    alerta.hierarchicalCategories.lvl1
                  ).map(option => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </div>
            )}
            <div>
              <label htmlFor="talla">*Talla:</label>
              <select
                id="talla"
                name="talla"
                value={alerta.talla}
                onChange={handleChange}
                required
              >
                <option value="">Seleccionar</option>
                <option value="">--Tallas Ropa</option>
                <option value="3xs">3XS</option>
                <option value="xxs">XXS</option>
                <option value="xs">XS</option>
                <option value="s">S</option>
                <option value="m">M</option>
                <option value="l">L</option>
                <option value="xl">XL</option>
                <option value="xxl">XXL</option>
                <option value="3xl">3XL</option>
                <option value="4xl">4XL</option>
                <option value="">--Tallas Calzado</option>
                <option value="35">35</option>
                <option value="36">36</option>
                <option value="37">37</option>
                <option value="38">38</option>
                <option value="39">39</option>
                <option value="40">40</option>
                <option value="41">41</option>
                <option value="42">42</option>
                <option value="43">43</option>
                <option value="44">44</option>
                <option value="45">45</option>
              </select>
            </div>
            <div>
              <label htmlFor="estado">*Estado:</label>
              <select
                id="estado"
                name="estado"
                value={alerta.estado}
                onChange={handleChange}
                required           
              >
                <option value="">Seleccionar</option>
                <option value="nuevo">Nuevo</option>
                <option value="como nuevo">Cómo nuevo</option>
                <option value="muy bueno">Muy bueno</option>
                <option value="bueno">Bueno</option>
                <option value="usado">Usado</option>
              </select>
            </div>
            <div>
              <label htmlFor="marca">Marca:</label>
              <select
                id="marca"
                name="marca"
                value={alerta.marca}
                onChange={handleChange}           
              >
                <option value="">Seleccionar</option>
                <option value="adidas">Adidas</option>
                <option value="abercrombie & fitch">Abercrombie & Fitch</option>
                <option value="alcott">Alcott</option>
                <option value="armand thiery">Armand Thiery</option>
                <option value="asics">Asics</option>
                <option value="asos">ASOS</option>
                <option value="balenciaga">Balenciaga</option>
                <option value="bershka">Bershka</option>
                <option value="bizzbee">Bizzbee</option>
                <option value="bonobo">Bonobo</option>
                <option value="boohoo">Boohoo</option>
                <option value="boohooman">BoohooMAN</option>
                <option value="brice">Brice</option>
                <option value="c&a">C&A</option>
                <option value="calvin klein">Calvin Klein</option>
                <option value="cargo">Cargo</option>
                <option value="carhartt">Carhartt</option>
                <option value="carrera">Carrera</option>
                <option value="celio">Celio</option>
                <option value="champion">Champion</option>
                <option value="chevignon">Chevignon</option>
                <option value="columbia">Columbia</option>
                <option value="converse">Converse</option>
                <option value="cortefiel">Cortefiel</option>
                <option value="corteiz">Corteiz</option>
                <option value="decathlon">Decathlon</option>
                <option value="desigual">Desigual</option>
                <option value="devred">Devred</option>
                <option value="diadora">Diadora</option>
                <option value="dickies">Dickies</option>
                <option value="diesel">Diesel</option>
                <option value="dockers">Dockers</option>
                <option value="dsquared2">Dsquared2</option>
                <option value="easy wear">Easy Wear</option>
                <option value="eden park">Eden Park</option>
                <option value="el corte ingles">El Corte Inglés</option>
                <option value="element">Element</option>
                <option value="ellesse">Ellesse</option>
                <option value="esprit">Esprit</option>
                <option value="fila">FILA</option>
                <option value="fred perry">Fred Perry</option>
                <option value="g-star">G-Star</option>
                <option value="guess">GUESS</option>
                <option value="geox">Geox</option>
                <option value="giacca">Giacca</option>
                <option value="giuseppe zanotti">Giuseppe Zanotti</option>
                <option value="gemo">Gémo</option>
                <option value="h&m">H&M</option>
                <option value="hogan">Hogan</option>
                <option value="hollister">Hollister</option>
                <option value="hugo boss">Hugo Boss</option>
                <option value="inside(24)">Inside</option>
                <option value="jack & jones">Jack & Jones</option>
                <option value="jaded london">Jaded London</option>
                <option value="jeckerson">Jeckerson</option>
                <option value="jennyfer">Jennyfer</option>
                <option value="joma">Joma</option>
                <option value="jordan">Jordan</option>
                <option value="jules">Jules</option>
                <option value="kalenji">Kalenji</option>
                <option value="kaporal">Kaporal</option>
                <option value="kappa">Kappa</option>
                <option value="kenzo">Kenzo</option>
                <option value="kiabi">Kiabi</option>
                <option value="kipsta">Kipsta</option>
                <option value="lacoste">Lacoste</option>
                <option value="le coq sportif">Le Coq Sportif</option>
                <option value="lee">Lee</option>
                <option value="lefties">Lefties</option>
                <option value="levi strauss & co.">Levi Strauss & Co.</option>
                <option value="levis">Levi's</option>
                <option value="lotto">Lotto</option>
                <option value="mizuno">MIZUNO</option>
                <option value="mango">Mango</option>
                <option value="massimo dutti">Massimo Dutti</option>
                <option value="minus twø">Minus Twø</option>
                <option value="munich">Munich</option>
                <option value="nasa">NASA</option>
                <option value="napapijri">Napapijri</option>
                <option value="new balance">New Balance</option>
                <option value="nike">Nike</option>
                <option value="ovs">OVS</option>
                <option value="off-white">Off-White</option>
                <option value="pepe jeans">Pepe Jeans</option>
                <option value="polo-ralph-lauren">Polo Ralph Lauren</option>
                <option value="primark">Primark</option>
                <option value="pull & bear">Pull & Bear</option>
                <option value="puma">Puma</option>
                <option value="pyrex">Pyrex</option>
                <option value="quiksilver">Quiksilver</option>
                <option value="ralph lauren">Ralph Lauren</option>
                <option value="redskins">Redskins</option>
                <option value="reebok">Reebok</option>
                <option value="salomon">Salomon</option>
                <option value="saucony">Saucony</option>
                <option value="scalpers">Scalpers</option>
                <option value="schott">Schott</option>
                <option value="sfera">Sfera</option>
                <option value="shein">Shein</option>
                <option value="shimano">Shimano</option>
                <option value="springfield">Springfield</option>
                <option value="stradivarius">Stradivarius</option>
                <option value="superdry">Superdry</option>
                <option value="tex">TEX</option>
                <option value="teddy smith">Teddy Smith</option>
                <option value="the north face">The North Face</option>
                <option value="timberland">Timberland</option>
                <option value="tommy hilfiger">Tommy Hilfiger</option>
                <option value="tommy jeans">Tommy Jeans</option>
                <option value="umbro">Umbro</option>
                <option value="under armour">Under Armour</option>
                <option value="uniqlo">Uniqlo</option>
                <option value="uomo">Uomo</option>
                <option value="vans">Vans</option>
                <option value="vera pelle">Vera Pelle</option>
                <option value="volcom">Volcom</option>
                <option value="woolrich">Woolrich</option>
                <option value="yeezy">Yeezy</option>
                <option value="zara">Zara</option>
              </select>
            </div>
            <div>
              <label htmlFor="color">Color:</label>
              <select
                id="color"
                name="color"
                value={alerta.color}
                onChange={handleChange}           
              >
                <option value="">Seleccionar</option>
                <option value="amarillo">Amarillo</option>
                <option value="azul">Azul</option>
                <option value="beige">Beige</option>
                <option value="blanco">Blanco</option>
                <option value="celeste">Celeste</option>
                <option value="dorado">Dorado</option>
                <option value="gris">Gris</option>
                <option value="marron">Marrón</option>
                <option value="morado">Morado</option>
                <option value="naranja">Naranja</option>
                <option value="negro">Negro</option>
                <option value="plateado">Plateado</option>
                <option value="rojo">Rojo</option>
                <option value="rosa">Rosa</option>
                <option value="turquesa">Turquesa</option>
                <option value="verde">Verde</option>
                <option value="violeta">Violeta</option>
              </select>
            </div>
            <div>
              <label htmlFor="precioMax">Precio Máximo:</label>
              <input
                type="number"
                id="precioMax"
                name="precioMax"
                value={alerta.precioMax}
                onChange={handleChange}          
              />
            </div>
            {usarIA && (
              <>
                <div>
                  <label htmlFor="rebajaEuros" className="label-con-info">
                    Rebaja en Euros:
                    <span className="info-container">
                      <span className="info-icon">
                        <FontAwesomeIcon icon={faCircleInfo} />
                      </span>
                      <div className="info-tooltip">
                        Pon un valor entre -x y 0 para buscar productos que estén rebajados x euros o más. Este campo lo calculamos con nuestro modelo de IA.
                      </div>
                    </span>
                  </label>
                  <input
                    type="number"
                    id="rebajaEuros"
                    name="rebajaEuros"
                    min="-100"
                    max="0"
                    value={alerta.rebajaEuros}
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <label htmlFor="rebajaPorcentaje" className="label-con-info">
                    Rebaja en %:
                    <span className="info-container">
                      <span className="info-icon">
                        <FontAwesomeIcon icon={faCircleInfo} />
                      </span>
                      <div className="info-tooltip">
                        Pon un valor entre -x% y 0% para buscar productos que estén rebajados x porcentaje o más. Este campo lo calculamos con nuestro modelo de IA.
                      </div>
                    </span>
                  </label>
                  <input
                    type="number"
                    id="rebajaPorcentaje"
                    name="rebajaPorcentaje"
                    min="-100"
                    max="0"
                    value={alerta.rebajaPorcentaje}
                    onChange={handleChange}
                  />
                </div>
            </>
          )}
            <button type="submit" className='botton-crear-alerta'>Crear Alerta</button>
          </form>
        </div>
        <div className='mostrar-alertas'>
          <h2>
            Alertas Guardadas
            <span className="info-container">
              <span className="info-icon">
                <FontAwesomeIcon icon={faCircleInfo} />
              </span>
              <div className="info-tooltip">
                Aquí aparecerán los productos que cumplan con los requisitos especificados y que tengan menos de 1 semana de antigüedad. 
                Si no recibes correos con la información de las alertas, mira tu carpeta de spam o pon filtros más genéricos.
              </div>
            </span>
          </h2>

          {/* 🔍 Campo de filtro global */}
          <div className="filtro-alertas">
            <div className="filtro-input-wrapper">
              <input
                type="text"
                placeholder="Filtrar alertas por cualquier palabra..."
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
              {filtro && (
                <button
                  className="clear-filtro-btn"
                  onClick={() => setFiltro("")}
                  title="Borrar filtro"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              )}
            </div>
          </div>
          <ul className="alertas-list">
            {alertasGuardadas
              .filter((alerta) => {
                if (!filtro.trim()) return true;
                const texto = filtro.toLowerCase();

                // Convertimos todo el contenido de los datos a texto plano
                const values = Object.values(alerta.data)
                  .map((v) =>
                    typeof v === "object"
                      ? Object.values(v).join(" ").toLowerCase()
                      : String(v).toLowerCase()
                  )
                  .join(" ");

                return values.includes(texto);
              })
              .map((alerta) => (
                <li key={alerta.id} className="alerta-card">
                  <div className="alerta-header">
                    <span
                      className={`notification-indicator ${alerta.data.notificationState ? 'active' : ''}`}
                      title={
                        alerta.data.notificationState
                          ? `${alerta.data.newProductsCount} productos nuevos disponibles`
                          : "Sin novedades"
                      }
                    >
                      {alerta.data.notificationState && alerta.data.newProductsCount > 0
                        ? alerta.data.newProductsCount
                        : ""}
                    </span>
                    <h4>{alerta.data.tituloAlerta}</h4>
                  </div>

                  <div className="alerta-info">
                    {alerta.data.sexo && <p><strong>Sexo:</strong> {upperFL(alerta.data.sexo)}</p>}
                    {alerta.data.hierarchicalCategories && (
                      <p><strong>Categoría:</strong> {upperFL(alerta.data.hierarchicalCategories.lvl2 || alerta.data.hierarchicalCategories.lvl1 || alerta.data.hierarchicalCategories.lvl0)}</p>
                    )}
                    {alerta.data.talla && <p><strong>Talla:</strong> {upperFL(alerta.data.talla)}</p>}
                    {alerta.data.estado && <p><strong>Estado:</strong> {upperFL(alerta.data.estado)}</p>}
                    {alerta.data.marca && <p><strong>Marca:</strong> {upperFL(alerta.data.marca)}</p>}
                    {alerta.data.color && <p><strong>Color:</strong> {upperFL(alerta.data.color)}</p>}
                    {alerta.data.ubicacion && <p><strong>Ubicación:</strong> {upperFL(alerta.data.ubicacion)}</p>}
                    {alerta.data.precioMax && <p><strong>Precio Máximo:</strong> {upperFL(alerta.data.precioMax)}€</p>}
                    {alerta.data.rebajaEuros && <p><strong>Rebaja (€):</strong> {upperFL(alerta.data.rebajaEuros)}€</p>}
                    {alerta.data.rebajaPorcentaje && <p><strong>Rebaja (%):</strong> {upperFL(alerta.data.rebajaPorcentaje)}%</p>}
                  </div>

                  <div className="alerta-actions">
                    <button className="boton-ver" onClick={() => toggleProducts(alerta.id)}>Ver Productos</button>
                    <button className="boton-eliminar" onClick={() => handleDeleteAndRefresh(user.uid, alerta.id)}>Eliminar</button>
                  </div>
                </li>
              ))}
          </ul>

          {/* Popup de productos */}
          <ProductosPopup
            isOpen={isPopupOpen}
            onClose={() => setIsPopupOpen(false)}
            alerta={selectedAlert}
            productos={selectedAlert ? products[selectedAlert.id] : undefined}
            premium={premium}
            planName={planName}
            user={user}
          />
        </div>
      </div>
    </div>
    );
    };